<template>
    <div style="height: 100vh;width: 100vw;">
        <!-- 页头 -->
        <nav-header2 style="position: absolute;z-index: 999;"></nav-header2>
        <div style="height: 60px;"></div>
        <div style="display: flex;height: calc(100% - 60px);width: 100%;">
            <!-- 侧边栏 -->
            <side-bar></side-bar>
            <div class="content" style="flex: 1;padding: 10px;background-color: #e4e7ed;display: flex;">
                <div class="top flex">
                    <p class="title">状态</p>
                    <ul class="website flex">
                        <li>
                            <svg-icon :paths="$svgs.iconsdata.userProfile.paths" size="33"></svg-icon>
                            <div>
                                <p>用户总数</p>
                                <p>{{ overviewdata.userTotal }}</p>
                                <p>近7日新增：{{ overviewdata.recentUserCount || 0 }}</p>
                            </div>
                        </li>
                        <li>
                            <svg-icon :paths="$svgs.iconsdata.gatewaysTotal.paths" size="38"></svg-icon>
                            <div>
                                <p>网关总数</p>
                                <p>{{ overviewdata.gatewayCount }}</p>
                                <p>近7日新增：{{ overviewdata.recentGatewayCount || 0 }}</p>
                            </div>
                        </li>
                        <li>
                            <svg-icon :paths="$svgs.iconsdata.onoffline.paths"></svg-icon>
                            <div>
                                <p>网关在线/离线总数</p>
                                <p>{{ overviewdata.onlineCount || 0 }}/{{ overviewdata.offlineCount || 0 }}</p>
                            </div>
                        </li>
                        <li>
                            <svg-icon :paths="$svgs.iconsdata.gatewayaWaitActive.paths"></svg-icon>
                            <div>
                                <p>网关待激活数</p>
                                <p>{{ overviewdata.inactiveCount || 0 }}</p>
                            </div>
                        </li>
                        <li>
                            <svg-icon :paths="$svgs.iconsdata.networkTotal.paths"></svg-icon>
                            <div>
                                <p>网络总数</p>
                                <p>{{ overviewdata.networkCount || 0 }}</p>
                            </div>
                        </li>
                        <li>
                            <svg-icon :paths="$svgs.iconsdata.networkDevices.paths"></svg-icon>
                            <div>
                                <p>网络设备数</p>
                                <p>{{ overviewdata.networDeviceCount || 0 }}</p>
                            </div>
                        </li>
                    </ul>
                </div>
                <ul class="middle flex">
                    <li>
                        <svg-icon :paths="$svgs.iconsdata.status1.paths" size="32"></svg-icon>
                        <div>
                            <p>Effilink状态</p>
                            <p class="normal" v-if="balancedata.effilink == 'connected'">正常</p>
                            <p class="unnormal" v-else-if="balancedata.effilink == 'disconnected'">异常</p>
                            <p v-else></p>
                        </div>
                    </li>
                    <li>
                        <svg-icon :paths="$svgs.iconsdata.status2.paths" size="32"></svg-icon>
                        <div>
                            <p>数据库状态</p>
                            <p class="normal" v-if="balancedata.database == 'connected'">正常</p>
                            <p class="unnormal" v-else-if="balancedata.database == 'disconnected'">异常</p>
                            <p v-else></p>
                        </div>
                    </li>
                    <li>
                        <svg-icon :paths="$svgs.iconsdata.status3.paths" size="39"></svg-icon>
                        <div>
                            <p>MQTT状态</p>
                            <p class="normal" v-if="balancedata.mqtt == 'connected'">正常</p>
                            <p class="unnormal" v-else-if="balancedata.mqtt == 'disconnected'">异常</p>
                            <p v-else></p>
                        </div>
                    </li>
                    <li>
                        <svg-icon :paths="$svgs.iconsdata.status4.paths"
                            :viewBox="$svgs.iconsdata.status4.viewBox"></svg-icon>
                        <div>
                            <p>短信余量</p>
                            <p>{{ balancedata.balance }}</p>
                        </div>
                    </li>
                </ul>
                <div class="echarts flex">
                    <div class="left flex">
                        <div class="list">
                            <p class="title">快捷方式</p>
                            <ul class="content-bl flex">
                                <li @click="shortcutRouter('1')">
                                    <svg-icon :paths="$svgs.iconsdata.shortcut1.paths" size="48"></svg-icon>
                                    <p>SN管理</p>
                                </li>
                                <li @click="shortcutRouter('2')">
                                    <svg-icon :paths="$svgs.iconsdata.shortcut2.paths" size="48"></svg-icon>
                                    <p>产品中心</p>
                                </li>
                                <li @click="shortcutRouter('3')">
                                    <svg-icon :paths="$svgs.iconsdata.shortcut3.paths" size="48"></svg-icon>
                                    <p>客户列表</p>
                                </li>
                            </ul>
                        </div>
                        <div class="list">
                            <p class="title system-msg">系统信息</p>
                            <ul class="system-list">
                                <li>
                                    <p>主机名：</p>
                                    <p>{{ menudata.hostname }}</p>
                                </li>
                                <li>
                                    <p>系统架构：</p>
                                    <p>{{ menudata.arch }}</p>
                                </li>
                                <li>
                                    <p>内核版本：</p>
                                    <p>{{ menudata.type }}</p>
                                </li>
                                <li>
                                    <p>程序版本：</p>
                                    <p>{{ menudata.version }}</p>
                                </li>
                                <li>
                                    <p>CPU：</p>
                                    <p>{{ menudata.cpuModel }}</p>
                                </li>
                                <li>
                                    <p>CPU核心数：</p>
                                    <p>{{ menudata.cpuCount }}</p>
                                </li>
                                <li>
                                    <p>磁盘：</p>
                                    <p>{{ menudata.diskFormatted }}</p>
                                </li>
                                <li>
                                    <p>内存：</p>
                                    <p>{{ menudata.memoryFormatted }}</p>
                                </li>
                                <li>
                                    <p>1/5/15分钟平均负载：</p>
                                    <p>{{ menudata.loadAverage }}</p>
                                </li>
                                <li>
                                    <p>运行时间：</p>
                                    <p>{{ menudata.uptimeFormatted }}</p>
                                </li>
                            </ul>
                        </div>
                    </div>
                    <div class="right flex">
                        <p class="title">型号统计</p>
                        <div class="echartsbox">
                            <div id="main"></div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import * as echarts from 'echarts';
// import { iconsdata } from '@/libs/svgicon'
// import * as svgicondata from '@/libs/svgicon'
// import { iconsData } from '@/libs/constant'
export default {
    data() {
        return {
            overviewdata: {},
            menudata: {},
            productdata: {},
            balancedata: {},
            menu: [],
            productName: ["product"],
            echartsArr: [
                {
                    product: '网关总数', name: 'gatewayCount',
                },
                {
                    product: '在线总数', name: 'onlineCount',
                },
                {
                    product: '离线总数', name: 'offlineCount',
                },
                {
                    product: '待激活总数', name: 'inactiveCount',
                },
            ],
            piedata: [],
            current: 1,
            size: 10,
        }
    },
    async created() {
        this.$js.token();
        sessionStorage.setItem('tabid', '10');
        sessionStorage.setItem('path', '/Overview');
        sessionStorage.setItem('netpage', '1');
        await this.getBalance()
        await this.getOverviewStatus()
        await this.getMenuData()
        await this.getOverviewProduct()

    },
    mounted() {
        this.menu = JSON.parse(sessionStorage.getItem('menu'));
    },
    computed: {
    },
    methods: {
        format(percentage) {
            return `负载\n
            ${percentage}%\nx'z'd
            运行流畅`;
        },
        // 状态统计
        async getOverviewStatus() {
            const res = await this.$apiFun.overviewstatus();
            this.overviewdata = res.data
            // console.log(res, 'dddddddd')
        },
        // 菜单状态
        async getMenuData() {
            const res = await this.$apiFun.overviewmenudata();
            this.menudata = res.data
            // console.log(res, 'dddd')
        },
        // 系统信息
        async getBalance() {
            const res = await this.$apiFun.overviewbalance();
            this.balancedata = res.data
            // console.log(res, 'dddd')
        },
        // 型号统计
        async getOverviewProduct() {
            const res = await this.$apiFun.overviewproduct();
            this.productdata = res.data
            // console.log(res, 'aa')
            this.productdata.forEach(itemp => {
                this.productName.push(itemp.productName)
            })
            this.productName.forEach((item, index) => {
                // console.log(item, 'ddddddddddd');
                if (index != 0) {
                    this.echartsArr.forEach(itemc => {
                        // console.log(itemc, item,'ddddddddddd');
                        itemc[item] = 0
                    })
                }
            })
            // console.log(this.echartsArr, 'this.echartsArr');
            this.productdata?.forEach((itemc, index) => {
                for (let i = 0; i < this.echartsArr.length; i++) {
                    // console.log(itemc, this.echartsArr[i], 'this.echartsArr[index]');
                    let value = itemc.productName == Object.keys(this.echartsArr[i])[index + 2]
                    if (value) {
                        this.echartsArr[i][itemc.productName] = itemc[this.echartsArr[i][Object.keys(this.echartsArr[i])[1]]]
                    }
                }
                this.piedata[index] = {}
                this.piedata[index]['name'] = itemc.productName
                this.piedata[index]['value'] = itemc.gatewayCount
            })
            this.initEcharts()
            // console.log(this.productName, this.echartsArr, Object.keys(this.echartsArr[1]), 'ddddddddddd66666666dd');
        },
        initEcharts() {
            var chartDom = document.getElementById('main');
            var myChart = echarts.init(chartDom, 'light');
            var option;
            option = {
                legend: {
                    data: this.productName.filter(item => item != 'product'),
                    bottom: 10
                },
                // color: ['#2f4554', '#61a0a8'],
                tooltip: {
                    trigger: 'axis',
                    axisPointer: { type: 'shadow' }
                },
                dataset: {
                    dimensions: this.productName,
                    source: this.echartsArr,
                },
                xAxis: { type: 'category' },
                yAxis: { type: 'value' },
                series: [
                ]
            };
            // 根据类别生成柱状图
            this.productName.forEach(item => {
                if (item != 'product') {
                    const params = {
                        type: 'bar',
                        barMaxWidth: 30,    // 像素上限
                        itemStyle: {
                            barBorderRadius: [10, 10, 0, 0],

                        }
                    }
                    option.series.push(params)
                }
            })
            // 扇形图
            option.series.push({
                type: 'pie',
                radius: ['0%', '30%'],
                center: ['75%', '20%'],
                data: this.piedata,
                minAngle: 10, // 最小15度
                label: {
                    show: true,
                },
                encode: {
                    itemName: 'productName',  // 映射自定义字段名
                    value: 'gatewayCount'        // 映射自定义数值字段
                },
                itemStyle: { borderColor: '#fff', borderWidth: 2 },
                tooltip: {
                    trigger: 'item',
                    // formatter: '网关总数： {c}'
                },
                z: 100  // 确保饼图在柱状图上层
            })
            // console.log(option, this.productName.filter(item => item != 'product'), 'option');
            option && myChart.setOption(option);
            window.addEventListener('resize', function () {
                myChart.resize();
            });
        },
        // 快捷方式路由跳转
        shortcutRouter(type) {
            console.log(type, 'fffffffffffffffffffffffff')
            if (type == '1') {
                sessionStorage.setItem('tabid', this.queryMenu('/ProductSn'));
                sessionStorage.setItem('path', '/ProductSn');
                this.$js.openpages('/ProductSn');
            } else if (type == '2') {
                sessionStorage.setItem('tabid', this.queryMenu('/ProductCenter'));
                sessionStorage.setItem('path', '/ProductCenter');
                this.$js.openpages('/ProductCenter');
            } else if (type == '3') {
                console.log(this.queryMenu('/UserData'), 'ddddddddddddddddddddddd')
                sessionStorage.setItem('tabid', this.queryMenu('/UserData'));
                sessionStorage.setItem('path', '/UserData');
                this.$js.openpages('/UserData');
            }
        },
        // 获取当前路由id
        queryMenu(value) {
            let routerId = ''
            this.menu = JSON.parse(sessionStorage.getItem('menu'));
            this.menu?.forEach(item => {
                if (item.adminMenuURL == value) {
                    routerId = item.id
                }
            })
            console.log(this.menu, routerId)
            return routerId
        }
    }
}
</script>

<style scoped lang="less">
:deep(.el-progress-circle) {
    width: 100px !important;
    height: 100px !important;
}

:deep(.el-progress__text) {
    font-size: 12px !important;
    color: #333 !important;
    white-space: pre-line;
}

.content {
    height: calc(100vh - 60px);
    flex-direction: column;
    row-gap: 16px;
    font-size: 14px;
    color: #333;
    overflow: auto;
}

.head-data {
    width: 100%;
    height: 160px;
    padding: 16px 20px;
    border-radius: 5px;
    background-color: #fff;
    color: #333;

    .progress {
        column-gap: 80px;
        margin-left: 60px;
    }
}

.title {
    font-size: 14px;
    margin-bottom: 15px;
    font-weight: bold;
}

.top {
    padding: 25px 16px 40px;
    background-color: #fff;
    flex-direction: column;
    // height: 120px;
    border-radius: 5px;
    min-width: 800px;
}

.website {
    margin-top: 5px;
    width: 100%;
    column-gap: 16px;
    justify-content: space-evenly;

    li {
        width: 300px;
        // height: 120px;
        border-radius: 5px;
        // padding: 16px;
        display: flex;
        position: relative;

        &:before {
            content: "";
            display: block;
            position: absolute;
            top: 50%;
            right: 0;
            margin-top: -45px;
            width: 1px;
            height: 90px;
            background-color: #ddd8d8;
        }

        &:last-child {
            &:before {
                content: none;
            }
        }

        img {
            width: 36px;
            height: 36px;
            margin-right: 10px;
        }

        div {
            margin-left: 8px;
        }

        p {
            font-size: 14px;

            &:nth-child(1) {
                margin-top: 5px;
            }

            &:nth-child(2) {
                font-size: 20px;
                // color: rgb(123, 199, 8);
                margin: 20px 0px;
            }
        }
    }
}

.middle {
    width: 100%;
    column-gap: 16px;
    min-width: 800px;

    li {
        // width: 190px;
        flex: 1;
        height: 120px;
        border-radius: 5px;
        padding: 16px;
        background-color: #fff;
        display: flex;
        align-items: center;
        position: relative;
        min-width: 170px;

        // img {
        //     width: 36px;
        //     height: 36px;
        //     margin-right: 10px;
        // }
        svg {
            flex-shrink: 0;
        }

        div {
            font-size: 14px;
            margin-left: 10px;
        }

        p {
            &:nth-child(1) {
                margin-top: 5px;
            }

            &:nth-child(2) {
                font-size: 12px;
                margin-top: 12px;
            }

            &:nth-child(3) {
                font-size: 12px;
            }
        }
    }
}

.echarts {
    column-gap: 16px;
    flex: 1;
    min-width: 800px;

    .left,
    .right {
        width: 50%;
        border-radius: 5px;
        min-width: 300px;
    }

    .right {
        background-color: #fff;
        padding: 16px;
        flex-direction: column;
    }

    .left {
        flex-direction: column;
        padding: 0;
        row-gap: 16px;

        .list {
            flex: 1;
            padding: 16px;
            background-color: #fff;
            border-radius: 5px;
        }
    }

    .content-bl {
        column-gap: 20px;

        // row-gap: 10px;
        // flex-wrap: wrap;
        li {
            width: 140px;
            height: 140px;
            padding: 16px;
            border: 1px dashed #ccc9c9;
            display: flex;
            align-items: center;
            justify-content: center;
            flex-direction: column;
            flex-shrink: 0;
            cursor: pointer;

            // img {
            //     width: 60px;
            //     height: 60px;
            //     margin-bottom: 30px;
            // }
            p {
                margin-top: 10px;
            }
        }
    }

    .title-btn {
        border-radius: 5px;
        width: 186px;
        height: 40px;
        background-color: #F1F1F1;
        align-items: center;
        justify-content: center;

        .el-button {
            padding: 0;
            width: 80px;
            height: 30px;
            color: #333;
            border: none;
            background-color: transparent;
            background-color: #fff;

            &:nth-child(1) {
                background-color: #fff;
            }

            &:hover {
                color: #333;
            }
        }
    }

    .content-br {
        align-items: center;
        justify-content: space-between;
        white-space: nowrap;

        .brl {
            align-items: center;

            p {
                margin-right: 8px;
            }
        }
    }

    .brc-list {
        margin-top: 30px;
        justify-content: space-around;

        li {
            justify-content: center;

            p {
                display: flex;
                justify-content: center;
                align-items: center;
                margin-bottom: 10px;

                &:nth-child(1) {
                    &:before {
                        content: "";
                        display: block;
                        width: 8px;
                        height: 8px;
                        background-color: #333;
                        border-radius: 50%;
                        margin-right: 2px;
                    }
                }
            }
        }
    }

    .system-list {
        margin-top: 24px;
        display: flex;
        column-gap: 12px;
        flex-wrap: wrap;
        font-size: 12px;

        li {
            width: 48%;
            display: flex;
            margin-bottom: 18px;

            p {
                &:nth-child(1) {
                    font-weight: bold;
                    margin-right: 3px;
                    white-space: nowrap;
                }
            }
        }
    }

    .echartsbox {
        position: relative;
        width: 100%;
        flex: 1;

        #main {
            position: absolute;
            width: 100%;
            height: 100%;
        }
    }
}

.normal,
.unnormal {
    padding: 4px 0px;
    width: 44px;
    background-color: #3fc9a033;
    color: #3fc9a0;
    text-align: center;
    margin-top: 15px !important;
}

.unnormal {
    padding: 4px 0px;
    width: 44px;
    color: #ff4d4d;
    background-color: rgba(255, 168, 168, 0.2);
}
</style>
